export const FieldTypes = {
  INSTRUCTIONS: 0, // ie, this is not a field, but instead just instructions for completing the form.
  FIELD_TEXT: 1,
  FIELD_INTEGER: 2,
  FIELD_TEXTAREA: 3,
  FIELD_DECIMAL: 4,
  FIELD_SELECTION: 5,
  FIELD_BOOLEAN: 6,
  FIELD_DATE: 7,
  FIELD_HTML: 8,
  FIELD_YESNO: 9,
  FIELD_DATETIME: 10,
  FIELD_CHECKBOXES: 11,
  FIELD_RADIOS: 12,
  FIELD_HIDDEN: 13
}

export function parseAnswer (form) {
  if (form.standardFormAnswer) {
    if (form.standardFormAnswer instanceof Object) {
      // console.log('answer is an object already!')
    } else {
      // console.log('answer is string.  Attempt to parse as JSON')
      form.standardFormAnswer = JSON.parse(form.standardFormAnswer)
    }
  } else {
    // No answer yet, initialize the boolean values of the questions
    for (let q = 0; q < form.standardFormQuestions.length; q++) {
      const question = form.standardFormQuestions[q]
      if (question.standardFormFieldAnswerType === FieldTypes.FIELD_BOOLEAN && question.answer === undefined) {
        question.answer = false
      }
    }
  }
}
